export type MethodId = 1 | 2 | 3 | 4;

export const METHODS: Record<MethodId, { full: string; short: string }> = {
  1: { full: "Method 1 — Direct API", short: "Method 1" },
  2: { full: "Method 2 — On-site agent", short: "Method 2" },
  3: { full: "Method 3 — Secure file transfer", short: "Method 3" },
  4: { full: "Method 4 — Push API", short: "Method 4" },
};

export const SELF_HOSTED_LABEL = "Self-hosted";
